<dbw-investor-viewer-accordion
  anchorId="investor-viewer-revenus-charges"
  accordionTitle="Revenus et charges"
  [itemsCount]="items().length">
  <div class="section-stack">
    <section class="sub-card dbw-card dbw-card--md">
      <div class="subheading"><h5>Revenus</h5></div>
      @if (revenueItems().length === 0) {
        <div class="empty-inline">Aucun revenu disponible.</div>
      } @else {
        <div class="section-stack">
          @for (item of revenueItems(); track item.revenueChargeId) {
            <article class="mini-card dbw-card dbw-card--lg">
              <div class="entity-header entity-header--compact">
                <div>
                  <h5>{{ formatText(item.designation) }}</h5>
                  <p>
                    Revenu #{{ item.revenueChargeId }} • ArianeId
                    {{ formatText(item.arianeId) }} • Nature
                    {{ formatText(item.natureCode) }} • Détention
                    {{ formatText(item.ownershipCode) }}
                  </p>
                </div>
                <strong class="entity-value">{{
                  formatCurrency(item.amount)
                }}</strong>
              </div>
              <div class="content-short">
                <div>Type: {{ formatText(item.typeCode) }}</div>
                <div>Détenteurs: {{ item.holders.length }}</div>
                @if (item.notes?.trim()) {
                  <div>Note: {{ item.notes }}</div>
                }
              </div>
              @if (item.holders.length > 0) {
                <div class="field-chip-list">
                  @for (holder of item.holders; track $index) {
                    <span class="field-chip">{{
                      formatHolderLabel(holder.investorId)
                    }}</span>
                  }
                </div>
              }
              @if (parseAdditionalFields(item.additionalFieldsJson).length > 0) {
                <div class="field-chip-list">
                  @for (
                    field of parseAdditionalFields(item.additionalFieldsJson);
                    track $index
                  ) {
                    <span class="field-chip"
                      >{{ field.label }}: {{ field.value }}</span
                    >
                  }
                </div>
              }
            </article>
          }
        </div>
      }
    </section>

    <section class="sub-card dbw-card dbw-card--md">
      <div class="subheading"><h5>Charges</h5></div>
      @if (chargeItems().length === 0) {
        <div class="empty-inline">Aucune charge disponible.</div>
      } @else {
        <div class="section-stack">
          @for (item of chargeItems(); track item.revenueChargeId) {
            <article class="mini-card dbw-card dbw-card--lg">
              <div class="entity-header entity-header--compact">
                <div>
                  <h5>{{ formatText(item.designation) }}</h5>
                  <p>
                    Charge #{{ item.revenueChargeId }} • ArianeId
                    {{ formatText(item.arianeId) }} • Nature
                    {{ formatText(item.natureCode) }} • Détention
                    {{ formatText(item.ownershipCode) }}
                  </p>
                </div>
                <strong class="entity-value">{{
                  formatCurrency(item.amount)
                }}</strong>
              </div>
              <div class="content-short">
                <div>Type: {{ formatText(item.typeCode) }}</div>
                <div>Détenteurs: {{ item.holders.length }}</div>
                @if (item.notes?.trim()) {
                  <div>Note: {{ item.notes }}</div>
                }
              </div>
              @if (item.holders.length > 0) {
                <div class="field-chip-list">
                  @for (holder of item.holders; track $index) {
                    <span class="field-chip">{{
                      formatHolderLabel(holder.investorId)
                    }}</span>
                  }
                </div>
              }
              @if (parseAdditionalFields(item.additionalFieldsJson).length > 0) {
                <div class="field-chip-list">
                  @for (
                    field of parseAdditionalFields(item.additionalFieldsJson);
                    track $index
                  ) {
                    <span class="field-chip"
                      >{{ field.label }}: {{ field.value }}</span
                    >
                  }
                </div>
              }
            </article>
          }
        </div>
      }
    </section>
  </div>
</dbw-investor-viewer-accordion>
